import { Checkbox } from '@/component'
import { cn } from '@/lib/utils'
export function CheckboxCard({
  checked,
  isBatchMode,
  onCheckedChange,
  children,
  position = 'left',
  className,
  disabled = false,
}: {
  checked: boolean
  isBatchMode: boolean
  onCheckedChange: (checked: boolean) => void
  children: React.ReactNode
  position?: 'left' | 'right'
  className?: string
  disabled?: boolean
}) {
  return (
    <div className="relative group w-full min-w-0">
      <Checkbox
        className={cn(
          'bg-background group-hover:opacity-100 opacity-0 z-11 absolute top-2',
          {
            'opacity-100': isBatchMode,
            'left-2': position === 'left',
            'right-2': position === 'right',
          },
          className,
        )}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
      />
      <div className="w-full min-w-0">{children}</div>
    </div>
  )
}
